<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12">
        <router-link
          to="/principal/warehouse/add"
          class="btn btn-secondary"
          v-if="$can('create', 'Almacenes')"
        >Agregar Almacén</router-link>
      </div>
    </div>
    <vue-good-table
      mode="remote"
      :columns="columns"
      :rows="rows"
      :totalRows="totalRecords"
      :sort-options="{
          enabled: true,
          initialSortBy: [{field: 'name', type: 'asc'}]
        }"
      :isLoading.sync="isLoading"
      styleClass="vgt-table bordered"
      :pagination-options="{
          enabled: true,
          mode: 'registros',
          position: 'top',
          perPage: 10,
          nextLabel: 'siguiente',
          prevLabel: 'anterior',
          rowsPerPageLabel: 'Filas por página',
          ofLabel: 'de',
          pageLabel: 'páginas', // for 'pages' mode
          allLabel: 'Todos',
        }"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter"
      @on-per-page-change="onPerPageChange"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'config' ">
          <button class="btn btn-secondary m-2" @click="openModal(props)" v-if="myRoleId === 1">
            <font-awesome-icon :icon="['fa', 'pencil-alt']" size="1x"/>
          </button>
          <button class="btn btn-info m-2" @click="go(props)"  >
            <font-awesome-icon :icon="['fa', 'cog']" size="1x"/>
          </button>
          <button class="btn btn-danger m-2" @click="eliminarAlmacen(props.row)" v-if="myRoleId === 1" >
            <font-awesome-icon :icon="['fa', 'trash']" size="1x"/>
          </button>
        </span>
      </template>
    </vue-good-table>
    <modal name="editInfo" :scrollable="true" height="auto" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('editInfo')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="reset-pass">
        <h2 class="text-center">Editar Información</h2>
        <div class="form-group col-11">
           <label for="exampleInputEmail1">Nombre</label>
           <input type="text" class="form-control ml-3" v-model="edit.name" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nombre">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1">Descripción</label>
            <input type="text" class="form-control ml-3" v-model="edit.description" placeholder="Descripción breve">
        </div>
        <div class="form-group col-11 text-center">
          <button class="btn btn-purple" @click="actualizar">Guardar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'

export default {
  mixins: [formatData],
  components: {
    VueGoodTable
  },
  data () {
    return {
      edit: {
        name: '',
        descriptiopn: ''
      },
      rows: [],
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'ID',
          field: 'id',
          filterOptions: {
            placeholder: 'ID del almacén',
            enabled: true
          }
        },
        {
          label: 'Nombre',
          field: 'name',
          filterOptions: {
            placeholder: 'Nombre',
            enabled: true
          }
        },
        {
          label: 'Descripción',
          field: 'description',
          filterOptions: {
            placeholder: 'Descripcion',
            enabled: true
          }
        },
        {
          label: 'Configurar Parametros',
          field: 'config',
          thClass: 'text-center',
          tdClass: 'text-center'
        }
      ]
    }
  },
  computed: {
    myRoleId () {
      return this.$store.getters.currentRoleId
    }
  },
  methods: {
    go (info) {
      this.$router.push({ name: 'productsWarehouse', params: info })
    },
    openModal (prop) {
      this.$modal.show('editInfo')
      console.log(prop)
      this.edit.name = prop.row.name
      this.edit.description = prop.row.description
      this.edit.id = prop.row.id
    },
    async actualizar () {
      try {
        const request = {
          name: this.edit.name,
          description: this.edit.description,
          id: this.edit.id
        }
        const orders = await axiosAdelaService.post('/updateAlmacen', request)
        console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.loadItems()
          this.$modal.hide('editInfo')
          this.$toastedPush({
            message: 'Almacén atualizado..',
            type: 'success'
          })
        }
      } catch (error) {
        this.showError('No se pudo actualizar el almacen, intentelo mas tarde...')
      }
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      this.loadItems()
    },
    async loadItems (first = false) {
      try {
        const response = await axiosAdelaService.post('/getWarehouses')
        console.log('', response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          this.rows = response.data.rows
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    },
    fmt (val) {
      return parseFloat(val || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })
    },

    async eliminarAlmacen (almacen) {
      console.log(almacen)
      const h = this.$createElement

      // Creamos un mensaje con advertencia visual
      const mensajeVNode = h('div', { class: ['text-center', 'p-2'] }, [
        h('b-icon', {
          props: { icon: 'exclamation-triangle-fill', variant: 'danger', fontScale: '3' },
          class: ['mb-3']
        }),
        h('h4', { class: ['text-dark', 'mb-3'] }, '¿Estás seguro?'),
        h('p', { class: ['text-muted'] }, [
          'Estás a punto de eliminar el almacén: ',
          h('strong', { class: ['text-danger'] }, almacen.name)
        ]),
        h('div', { class: ['alert', 'alert-secondary', 'small'] }, [
          h('i', 'Esta acción no se puede deshacer. Se perderán los registros de inventario asociados a esta ubicación.')
        ])
      ])

      // Lanzamos el cuadro de confirmación
      const confirm = await this.$bvModal.msgBoxConfirm([mensajeVNode], {
        title: 'Confirmar Eliminación',
        okTitle: 'ELIMINAR AHORA',
        cancelTitle: 'CANCELAR',
        okVariant: 'danger',
        cancelVariant: 'outline-secondary',
        centered: true,
        size: 'md',
        noCloseOnBackdrop: true // Obliga a elegir una opción
      })

      if (confirm) {
        try {
          // Aquí llamas a tu API
          // await axios.delete(`/api/almacenes/${almacen.id}`);
          await axiosAdelaService.post('/deleteWarehouse', { id: almacen.id })
          // console.log(response)
          this.$bvToast.toast(`El almacén "${almacen.name}" fue eliminado correctamente.`, {
            title: 'Éxito',
            variant: 'success',
            solid: true
          })
          this.loadItems()
          // Refrescar lista o lógica adicional
        } catch (error) {
          console.log(error)
          this.$bvToast.toast('No se pudo eliminar el almacén porque tiene movimientos activos.', {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        }
      }
    }
  },
  mounted () {
    this.loadItems(true)
  }
}
</script>

<style>

</style>
